import { Link } from "react-router-dom";
import Error from "../../Layouts/Error";
import InnerHeader from "../../Layouts/InnerHeader";
import Loading from "../../Layouts/Loading";
import { useGetFactorsQuery } from "../../Redux/Apis/shopApi";
import { fa_currency, fa_date } from "../../utils/Persian";

function status_types(type:string) {
    switch (type) {
        case "WAIT":
            return "در حال انجام";
        case "SUCCESS":
            return "نهایی شده";
        case "CANCELLED":
            return "کنسل شده";
        case "EXPIRED":
            return "منقضی شده";
        default:
            return type;
    }
}

export default function Factor(){
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetFactorsQuery({})
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess)
        return(
            <div className="container-lg">
                <InnerHeader name="فاکتور ها"/>
                <div className="row">
                    {data && data.length > 0 ? 
                    <div className="table-responsive"><table className="table">
                        <thead>
                            <tr>
                            <th scope="col">شناسه</th>
                            <th scope="col">نام مشتری</th>
                            <th scope="col">مبلغ فاکتور</th>
                            <th scope="col">تاریخ</th>
                            <th scope="col">نحوه پرداخت</th>
                            <th scope="col">نحوه ارسال</th>
                            <th scope="col">وضعیت سفارش</th>
                            <th scope="col">جزئیات</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map((value:any,index:number) => 
                            <tr key={index}>
                                <th scope="row">{value.hash}</th>
                                <td>{value.Client.name + " " + value.Client.family}</td>
                                <td>{fa_currency(+value.price)}</td>
                                <td>{fa_date(value.create_date)}</td>
                                <td>{value.SitePayment.name}</td>
                                <td>{value.SiteShipping.name}</td>
                                <td className={`${value.status === "SUCCESS" ? "text-success" : "text-danger"}`}>{status_types(value.status)}</td>
                                <td>
                                <Link
                                    to={`/factor/${value.id}`}
                                    className="me-2 text-secondary border p-1 rounded"
                                    role="button"
                                    style={{textDecoration:'none'}}
                                >
                                    <i className='zmdi zmdi-info'></i> مشاهده جزئیات
                                </Link>
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table></div>
                    :
                    <div className="alert d-flex align-items-center" role="alert">
                        <i className="zmdi zmdi-info"></i>
                        <div className="ms-2">
                            فاکتوری یافت نشد.
                        </div>
                    </div>
                    }
                </div>
            </div>
        )

    else return <></>
}